"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.withHighContrastMode = exports.getHighContrastMode = exports.whichThemeInHighContrastMode = exports.fullColorHex = exports.rgbToHex = exports.highContrastModeBackgroundColor = exports.getRoleButtonAttributes = exports.getHelperAttributes = exports.getLabelAttributes = exports.getInputAttributes = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var INPUT_SUFFIX = 'input';
var LABEL_SUFFIX = 'input-label';
var HELPER_SUFFIX = 'input-helper';
/**
 * Returns the ARIA attributes needed for an input element.
 *
 * @param {string} name - the name of the input element
 * @param {boolean} [includeHelper=false] - (optional) indicates whether there is a Helper element in use
 * @return {object} - the ARIA attributes
 */

var getInputAttributes = function getInputAttributes(name) {
  var includeHelper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var inputAttributes = {
    id: "".concat(name, "-").concat(INPUT_SUFFIX),
    'aria-labelledby': "".concat(name, "-").concat(LABEL_SUFFIX)
  };

  if (includeHelper) {
    inputAttributes['aria-describedby'] = "".concat(name, "-").concat(HELPER_SUFFIX);
  }

  return inputAttributes;
};
/**
 * Returns the ARIA attributes needed for a label element.
 *
 * @param {string} name - the name of the input element to which the label applies
 * @return {object} - the ARIA attributes
 */


exports.getInputAttributes = getInputAttributes;

var getLabelAttributes = function getLabelAttributes(name) {
  return {
    id: "".concat(name, "-").concat(LABEL_SUFFIX),
    htmlFor: "".concat(name, "-").concat(INPUT_SUFFIX)
  };
};
/**
 * Returns the ARIA attributes needed for a helper element.
 *
 * @param {string} name - the name of the input element to which the label applies
 * @return {object} - the ARIA attributes
 */


exports.getLabelAttributes = getLabelAttributes;

var getHelperAttributes = function getHelperAttributes(name) {
  return {
    helperId: "".concat(name, "-").concat(HELPER_SUFFIX)
  };
};
/**
 * Returns the ARIA attributes needed for all the elements used in conjunction with an input element.
 *
 * @param {string} name - the name of the input element
 * @param {boolean} [includeHelper=false] - (optional) indicates whether there is a Helper element in use
 * @return {object} - the ARIA attributes
 */


exports.getHelperAttributes = getHelperAttributes;

var getAriaAttributes = function getAriaAttributes(name) {
  var includeHelper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var ariaAttributes = {
    input: getInputAttributes(name, includeHelper),
    label: getLabelAttributes(name)
  };

  if (includeHelper) {
    ariaAttributes.helper = getHelperAttributes(name);
  }

  return ariaAttributes;
};
/**
 * Returns the ARIA attributes as well as onClick and onKeyDown functions appropriate for role=button elements.
 *
 * @param {object} [options={}] - (optional) includes the following possible properties:
 *      {Function} clickHandler - function to use as onClick handler and onKeyDown callback
 *      {string} label - the label for the component
 * @return {object} - the ARIA attributes
 */


exports.default = getAriaAttributes;

var getRoleButtonAttributes = function getRoleButtonAttributes() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  /* eslint func-names: 0 */
  var clickHandler = options.clickHandler || function () {};

  var keyDownHandler = function keyDownHandler(e) {
    if (e.key === 'Enter') {
      clickHandler(e);
    }
  };

  var attributes = {
    role: 'button',
    tabIndex: '0',
    onClick: clickHandler,
    onKeyDown: keyDownHandler
  };

  if (options.label) {
    attributes['aria-label'] = options.label;
  }

  return attributes;
};
/**
 * Returns is browser in high contrast mode or not
 * @return {null | string} - returns null if High Contrast mode is turned off, otherwise it returns the background color.
 */


exports.getRoleButtonAttributes = getRoleButtonAttributes;

var highContrastModeBackgroundColor = function highContrastModeBackgroundColor() {
  var objDiv = document.createElement('div'); // unusual color to detect high contrast mode

  var rgbColor = 'rgb(176, 191, 26)';
  objDiv.style.backgroundColor = rgbColor;
  document.body.appendChild(objDiv);
  var isContrastModeEnable = document.defaultView ? document.defaultView.getComputedStyle(objDiv, null).backgroundColor !== rgbColor : objDiv.currentStyle.backgroundColor !== rgbColor;

  if (isContrastModeEnable) {
    var backgroundColor = document.defaultView ? document.defaultView.getComputedStyle(objDiv, null).backgroundColor : objDiv.currentStyle.backgroundColor;
    document.body.removeChild(objDiv);
    return backgroundColor;
  }

  document.body.removeChild(objDiv);
  return null;
};

exports.highContrastModeBackgroundColor = highContrastModeBackgroundColor;

var rgbToHex = function rgbToHex(rgb) {
  var hex = rgb.toString(16);

  if (hex.length < 2) {
    hex = "0".concat(hex);
  }

  return hex;
};

exports.rgbToHex = rgbToHex;

var fullColorHex = function fullColorHex(redColor, greenColor, blueColor) {
  var red = rgbToHex(redColor);
  var green = rgbToHex(greenColor);
  var blue = rgbToHex(blueColor);
  return red + green + blue;
}; // false - Dark Mode, true - Light Mode


exports.fullColorHex = fullColorHex;

var whichThemeInHighContrastMode = function whichThemeInHighContrastMode(hexNumber) {
  var hex = hexNumber;

  if (hex.indexOf('#') === 0) {
    hex = hex.slice(1);
  }

  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }

  var red = parseInt(hex.slice(0, 2), 16);
  var green = parseInt(hex.slice(2, 4), 16);
  var blue = parseInt(hex.slice(4, 6), 16);
  return red * 0.299 + green * 0.587 + blue * 0.114 > 186 ? 'light' : 'dark';
};
/**
 * Returns in which mode the browser is in
 * @return {null | string} - null if browser not in high contrast mode. "light" if browser in light high contrast mode. "dark" if browser in dark high contrast mode
 */


exports.whichThemeInHighContrastMode = whichThemeInHighContrastMode;

var getHighContrastMode = function getHighContrastMode() {
  var rgbBackground = highContrastModeBackgroundColor();

  if (!rgbBackground) {
    return null;
  }

  var rgbNumbers = rgbBackground.match(/\d+/g).map(Number);
  var hexColor = fullColorHex.apply(void 0, _toConsumableArray(rgbNumbers));
  var themeInHighContrastMode = whichThemeInHighContrastMode(hexColor);

  if (themeInHighContrastMode === 'light') {
    return 'light';
  }

  if (themeInHighContrastMode === 'dark') {
    return 'dark';
  }
};

exports.getHighContrastMode = getHighContrastMode;

var withHighContrastMode = function withHighContrastMode(WrappedComponent) {
  var highContrastMode = getHighContrastMode();

  var WithHighContrastMode =
  /*#__PURE__*/
  function (_React$PureComponent) {
    _inherits(WithHighContrastMode, _React$PureComponent);

    function WithHighContrastMode() {
      _classCallCheck(this, WithHighContrastMode);

      return _possibleConstructorReturn(this, _getPrototypeOf(WithHighContrastMode).apply(this, arguments));
    }

    _createClass(WithHighContrastMode, [{
      key: "render",
      value: function render() {
        return _react.default.createElement(WrappedComponent, _extends({}, this.props, {
          highContrastMode: highContrastMode
        }));
      }
    }]);

    return WithHighContrastMode;
  }(_react.default.PureComponent);

  WithHighContrastMode.displayName = "WithHighContrastMode(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
  return WithHighContrastMode;
};

exports.withHighContrastMode = withHighContrastMode;
